const DashboardLoader = ({ count }: { count: number }) => {
	return (
		<>
			<div className="flex gap-x-6 w-full" >
				{count > 0 &&
					Array.from({ length: count }).map((item: any, index: number) => (
						<div key={index} className="w-full">
							<div className="w-full h-screen rounded overflow-hidden animate-pulse p-8">
								<div className='w-full'>
									<div className="flex gap-5 mb-6">
										<div className='w-[334px] h-[254px] rounded-2xl bg-gray-200 flex-shrink-0 mr-4'></div>

										<div className='w-[334px] h-[254px] rounded-2xl bg-gray-200 flex-shrink-0 mr-4'></div>

										<div className='w-[334px] h-[254px] rounded-2xl bg-gray-200 flex-shrink-0 mr-4'></div>
									</div>
									<div className='h-6 w-3/4 bg-gray-200 rounded mb-5'></div>
									<div className='h-6 w-4/5 bg-gray-200 rounded mb-5'></div>
									<div className='h-6 w-3/5 bg-gray-200 rounded mb-5'></div>
									<div className='h-6 w-10/12 bg-gray-200 rounded mb-5'></div>

									<div className='h-6 w-3/4 bg-gray-200 rounded mb-5'></div>
									<div className='h-6 w-4/5 bg-gray-200 rounded mb-5'></div>
									<div className='h-6 w-3/5 bg-gray-200 rounded mb-5'></div>
									<div className='h-6 w-10/12 bg-gray-200 rounded'></div>
								</div>
							</div>
						</div>
					))
				}
			</div>
		</>
	);
}

export default DashboardLoader